import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, breakpoints, layout }: ITheme) => ({
    container: {
      marginBottom: 40,
      padding: [0, '48px'],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, '24px'],
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      padding: '64px 32px',
      overflow: 'hidden',

      backgroundColor: 'var(--x-bg-5)',
      borderRadius: '32px',

      maxWidth: layout.maxWidth,
      margin: 'auto',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '32px',
      },
    },
    title: {
      fontSize: '60px !important',
      marginBottom: '40px',
      textAlign: 'center',
      fontWeight: `${FontWeight.Medium} !important`,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '2.1429rem !important',
        marginBottom: '24px',
        lineHeight: '3rem !important',
      },
    },
    label: {
      fontSize: '1.4286rem !important',
      color: 'var(--x-text-color-2) !important',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '1.1428rem !important',
      },
    },
    steps: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: spacing.xxxLarge,

      marginBottom: '72px',

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        marginBottom: '52px',
      },
    },
    actions: {
      display: 'flex',
      justifyContent: 'center',
      gap: spacing.large,

      [mediaQuery(breakpoints.mobile)]: {
        flexDirection: 'column',
        justifyContent: 'stretch',
      },
    },
  }),
  {
    name: 'simplified-steps-section',
  },
);

export default useStyles;
